import { Component, HostListener, inject, Inject, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ApiService } from '../../services/api.service';
import { SearchModel } from '../../models/search-model';
import { YoutubeItem, YoutubeResponse } from '../../models/youtube-response';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SearchTerm } from 'src/app/state/user/searches/models/search';
import { ExternalVideoDialogFacade } from 'src/app/_core/state/dialogs/external-video/external-video.facade';

@Component({
  selector: 'app-youtube-results-dialog',
  templateUrl: './youtube-results-dialog.component.html',
  styleUrls: ['./youtube-results-dialog.component.scss'],
})
export class YoutubeResultsDialogComponent implements OnInit {
  private readonly externalVideoDialogFacade = inject(ExternalVideoDialogFacade);

  youtubeResponse: YoutubeResponse;
  youtubeItems: YoutubeItem[];

  searchForm: UntypedFormGroup;

  searching: boolean;
  hasResults: boolean;
  numResultsLabel: string;
  noResultsText: string;

  constructor(
    public dialogRef: MatDialogRef<YoutubeResultsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public searchModel: SearchModel,
    private dialog: MatDialog,
    private apiService: ApiService,
    private formBuilder: UntypedFormBuilder
  ) {}

  ngOnInit(): void {
    this.searchForm = this.formBuilder.group({
      query: ['', Validators.maxLength(60)],
    });

    this.getYoutubeResults();
  }

  getYoutubeResults(pageToken?: string) {
    if (this.searchModel.terms.length === 0) {
      this.hasResults = false;
      this.noResultsText = 'results.externalSearches.noResults';
      return;
    }

    if (pageToken == null) {
      this.youtubeItems = [];
    }

    this.searching = true;
    this.apiService.getYoutubeResources(this.searchModel.toYoutubeQuery(), pageToken).subscribe((result) => {
      this.searching = false;
      this.youtubeResponse = result;
      this.hasResults = result.totalResults > 0;
      this.numResultsLabel = result.totalResults > 999 ? '999+' : result.totalResults.toString();

      if (this.hasResults) {
        this.youtubeItems = pageToken == null ? result.items : this.youtubeItems.concat(result.items);
      } else {
        this.noResultsText = 'results.noResults';
      }
    });
  }

  removeTerm(term: SearchTerm) {
    this.searchModel.removeTerm(term);
    this.getYoutubeResults();
  }

  hasNextPage() {
    return this.youtubeResponse.totalResults > this.youtubeItems.length;
  }

  loadNextPage() {
    const nextPageToken = this.youtubeResponse.nextPageToken;
    this.getYoutubeResults(nextPageToken);
  }

  submit() {
    const rawTerm = this.searchForm.get('query').value as string;
    if (rawTerm != null && rawTerm.length > 0) {
      const term: SearchTerm = { field: 'allfields_txt', term: rawTerm };
      this.searchModel.addTerm(term);
    }

    this.searchForm.get('query').setValue('');
    this.getYoutubeResults();
  }

  @HostListener('scroll', ['$event'])
  onScroll(event: any) {
    const bottomReached = event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight;
    if (this.hasNextPage() && bottomReached) {
      this.loadNextPage();
    }
  }

  openVideoDialog(data: any) {
    data.searchTerms = this.searchModel.toYoutubeQuery();
    this.externalVideoDialogFacade.openDialog(data);
  }
}
